// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8960":"07014403","9515":"8234597b"}[chunkId] + ".chunk.css";
};